import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import Spinner from "../../../components/Spinner";
import searchicon from "../../../assets/img/s.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { calculateNowTime } from "../../../services/sharedService";
import useTranslator from "../../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  haveValue,
  getBaseUrl,
  validatePhoneNumber,
} from "../../../helper/common";
import { useCookies } from "react-cookie";
import { Modal, Row } from "react-bootstrap";
import { Slider, styled } from "@mui/material";
import AssignTenantLLModal from "./AssignTenantLLModal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ProfileTable from "../../../components/Profiles/ProfilesTable";

function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const ProfileRequest = () => {
  const { _t } = useTranslator();
  const RentSlider = styled(Slider)({
    color: "#A3EB64",
    height: 8,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "7px solid #253837",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&::before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 9,
      background: "unset",
      padding: 0,
      width: 38,
      height: 38,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#52af77",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&::before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  });
  const marks = [
    {
      value: 1,
      label: "1%",
    },
    {
      value: 100,
      label: "100%",
    },
  ];

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const {
    loadUserTenant,
    user,
    userType,
    loadMyNotifications,
    updateUserInfo,
  } = authContext;

  const tenantContext = useContext(TenantContext);
  const { shareProfile } = tenantContext;

  const landLordContext = useContext(LandLordContext);
  const {
    loadAgencyProfile,
    loadProfilesLandlord,
    fullProfileReceived,
    basicProfileReceived,
    properties,
    loadProperties,
  } = landLordContext;
  const [propertyFilter, setPropertyFilter] = useState("all");
  const [searchVal, setSearchVal] = useState("");
  const [rentPercentage, setRentPercentage] = useState(
    user?.rent_percentage ?? 1
  );
  const [rentDoc, setRentDoc] = useState("current_annual_income");

  const queryParameters = new URLSearchParams(window.location.search);

  //toggling between full and basic profile
  const [loading, setLoading] = useState(false);
  const [filteredFullProfiles, setFilteredFullProfiles] = useState([]);
  const [filteredBasicProfiles, setFilteredBasicProfiles] = useState([]);

  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);
  const [isChanged, setIsChanged] = useState(false);
  const [effortRateModal, setEffortRateModal] = useState(false);

  const [filters, setFilters] = useState({
    createdAt: "desc",
    myScore: "",
  });

  const [assignLLModal, setAssignLLModal] = useState({
    tenant_id: null,
    openModal: false,
  });

  const [effortRatePecentage, setEffortRatePecentage] =
    useState(rentPercentage);

  useEffect(() => {
    let userid = localStorage.getItem("saveduserid");
    if (haveValue(user?._id) || haveValue(userid)) {
      useeffectfunc();
    }
    loadProperties(userid);
  }, [filters]);

  useEffect(() => {
    if (haveValue(user?.rent_percentage)) {
      setRentPercentage(user?.rent_percentage);
      setEffortRatePecentage(user?.rent_percentage);
    }
    if (haveValue(user?.rent_from)) {
      setRentDoc(user?.rent_from);
    }
    useeffectfunc();
  }, [user]);

  const useeffectfunc = async () => {
    const sharedProfileLink = queryParameters.get("sharedProfileLink");
    const navigateTo = queryParameters.get("navigateTo");
    if (haveValue(navigateTo)) {
      navigate(`/${navigateTo}`);
    }
    if (haveValue(sharedProfileLink)) {
      await importProfileRedirect();
    } else {
      loadData();
    }
  };

  const loadData = () => {
    let userid = localStorage.getItem("saveduserid");
    if (user && user?._id) {
      setLoading(true);
      if (user?.isParentLL && haveValue(user?.agency_id)) {
        loadAgencyProfile(user?.agency_id)
          .then((res) => {
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        loadProfilesLandlord(user?._id, "full", filters)
          .then((res) => {
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      }
      // loadProfilesLandlord(user?._id, "basic");
    }
    // else if (haveValue(userid)) {
    //   setLoading(true);
    //   loadProfilesLandlord(userid, "full", filters)
    //     .then((res) => {
    //       setLoading(false);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setLoading(false);
    //     });
    //   // loadProfilesLandlord(userid, "basic");
    // }

    loadMyNotifications(userid, userType);
  };

  const importProfileRedirect = async () => {
    let userid = localStorage.getItem("saveduserid");
    const sharedProfileLink = queryParameters.get("sharedProfileLink");

    if (haveValue(sharedProfileLink)) {
      const done = await shareProfile(
        sharedProfileLink,
        userid,
        "null",
        "full",
        { shareType: "tLink" }
      );
      removeCookie("sharedProfileLink", { maxAge: 1800 });
      if (done) {
        toast.success(_t("profileImported"));
      }
      loadData();
      navigate("/profile-request");
    }
  };

  useEffect(() => {
    setFilteredFullProfiles(fullProfileReceived);
    setFilteredBasicProfiles(basicProfileReceived);
  }, [fullProfileReceived, basicProfileReceived]);

  useEffect(() => {
    handleNewResult();
  }, [searchVal, propertyFilter]);

  const searchTenant = async (e) => {
    //console.log(e.target.value);

    let q = e.target.value;
    setSearchVal(q);
  };

  const handleFilterChange = (e) => {
    const val = e.target.value;
    setPropertyFilter(val);
  };

  const handleNewResult = () => {
    let all_result = [...fullProfileReceived];
    const queryText = searchVal?.toLowerCase()?.trim() || "";
    const normalize = (str) =>
      str
        ?.toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^\w\s]/gi, "")
        .trim();

    const normalizedQuery = normalize(queryText);
    const tokens = normalizedQuery.split(" ").filter(Boolean);

    if (haveValue(queryText)) {
      // Find matching property IDs
      const matchedPropertyIDs = properties
        .filter((prop) => {
          const combined = normalize(
            [
              prop?.street,
              prop?.street_number,
              prop?.staircase,
              prop?.floor_number,
              prop?.flat_number,
            ]
              .filter(Boolean)
              .join(" ")
          );
          return tokens.every((t) => combined.includes(t));
        })
        .map((p) => p?._id);

      all_result = all_result.filter((item) => {
        const fname = normalize(
          `${item?.tenantid?.fname ?? ""} ${item?.tenantid?.lname ?? ""}`
        );
        const hasNameMatch = tokens.every((t) => fname.includes(t));

        const propertyIds = item?.propertyid?.map((p) => p) || [];
        const hasPropertyMatch = propertyIds.some((id) =>
          matchedPropertyIDs.includes(id)
        );

        return hasNameMatch || hasPropertyMatch;
      });
    }

    setFilteredFullProfiles(all_result);
  };

  const checkSalary = (user) => {
    if (haveValue(user?.gurantor_id) && haveValue(user?.gurantor_id?._id)) {
      if (user?.gurantor_id?.algoanIncome) {
        let monthlyIncome = parseInt(
          user?.gurantor_id?.algoanIncome?.monthlyAmount
        );
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user?.gurantor_id?.current_annual_income)
            ? user?.gurantor_id?.current_annual_income
            : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );

        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    } else {
      if (user?.algoanIncome) {
        let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user.current_annual_income) ? user.current_annual_income : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );
        console.log(salaryMatch, recorded_annual_salary, "NAMANCHECK2");
        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    }
  };

  const changeEffortRatePercentage = (e, val) => {
    setEffortRatePecentage(val);
    // setRentPercentage(val);
    setIsChanged(true);
  };

  const handleEffortRateSubmit = (e) => {
    e.preventDefault();
    setEffortRateModal(false);
    setRentPercentage(effortRatePecentage);
    handleChangeRent();
  };

  const eachRentAmount = (fullProfile) => {
    if (
      haveValue(fullProfile?.rent_from_income) &&
      haveValue(fullProfile?.rent_percentage)
    ) {
      if (fullProfile?.rent_from_income == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.current_annual_income || 0) *
                fullProfile?.rent_percentage) /
                1200
            )
          ) || 0
        );
      } else if (fullProfile?.rent_from_income == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.itr_amount || 0) *
                fullProfile?.rent_percentage) /
                1200
            )
          ) || 0
        );
      } else if (fullProfile?.rent_from_income == "recordedSalary") {
        const recordedSal = checkSalary(fullProfile?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(
              ((recordedSal?.salary || 0) * fullProfile?.rent_percentage) / 1200
            )
          ) || 0
        );
      }
    } else {
      if (rentDoc == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.current_annual_income || 0) *
                rentPercentage) /
                1200
            )
          ) || 0
        );
      } else if (rentDoc == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.itr_amount || 0) * rentPercentage) / 1200
            )
          ) || 0
        );
      } else if (rentDoc == "recordedSalary") {
        const recordedSal = checkSalary(fullProfile?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(((recordedSal?.salary || 0) * rentPercentage) / 1200)
          ) || 0
        );
      }
    }
  };

  const handleChangeRent = () => {
    const temp_data = {
      rent_from: rentDoc,
      rent_percentage: effortRatePecentage,
    };
    updateUserInfo(temp_data)
      .then((res) => {
        let usertype = localStorage.getItem("usertype");
        loadUserTenant(usertype);
      })
      .catch((err) => {
        console.log("Error while updating user info");
      });
    // setIsChanged(false);
  };

  const filterChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openAssignLLModal = (tenant_id) => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: tenant_id,
      openModal: true,
    }));
  };
  const handleCloseModal = () => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: null,
      openModal: false,
    }));
  };

  if (loading) return <Spinner />;

  console.log(fullProfileReceived, "fullProfileReceivedfullProfileReceived");

  return (
    <>
      <div className="tabs-box-pattern tabs-box-pattern-2 big_tablebg">
        <div className="tabs-item d-block p-0">
          <div className="row">
            <div className="profile-page marless mobile-max-less mobile-max-lesshead">
              <div className="Search-bar searchbar_cls">
                <p className="percentage_salary_p search_heading01">
                  {_t("Search")}
                </p>
                <div className="search_bar_edit">
                  <input
                    type="text"
                    className="custom-input mb-0 input01"
                    onChange={searchTenant}
                    value={searchVal}
                    placeholder={_t("Search")}
                  />
                  <a href="#">
                    <img src={searchicon} alt="" />
                  </a>
                </div>
              </div>

              <div>
                <p className="percentage_salary_p search_heading01">
                  {_t("incomeFrom")}
                </p>
                <div className="table_option_set">
                  <select
                    name="rent_from_income_select"
                    id="rent_from_income_select borderset"
                    className="custom-input income_select"
                    onChange={(e) => setRentDoc(e.target.value)}
                    value={rentDoc}
                    style={{ width: "100%" }}
                  >
                    <option value="current_annual_income">
                      {" "}
                      {_t("annualIncome")}{" "}
                    </option>
                    <option value="itr_amount">
                      {_t("verifiedIncomeFromIRPF")}
                    </option>
                    <option value="recordedSalary">
                      {_t("verifiedAnnualIncome")}
                    </option>
                  </select>
                  <div
                    onClick={() => setEffortRateModal(true)}
                    className="rent-percentage cursor-pointer rent-percentage2"
                  >
                    {rentPercentage}%
                  </div>
                </div>
              </div>

              <div className="form-group">
                <p className="percentage_salary_p search_heading01">
                  {_t("ProfileCompletion")}
                </p>
                <select
                  className="form-control share-filter share-filter2"
                  name="myScore"
                  value={filters["myScore"]}
                  onChange={filterChangeHandler}
                >
                  <option value="">{_t("select")}</option>
                  <option value="0">0%</option>
                  <option value="25">25%</option>
                  <option value="50">50%</option>
                  <option value="75">75%</option>
                  <option value="100">100%</option>
                </select>
              </div>
            </div>
            <ProfileTable
              profile={filteredFullProfiles}
              properties={properties}
              loadData={loadData}
              user={user}
              openAssignLLModal={openAssignLLModal}
              checkSalary={checkSalary}
              rentPercentage={rentPercentage}
              rentDoc={rentDoc}
            />
          </div>
        </div>
      </div>
      {assignLLModal.openModal && (
        <AssignTenantLLModal
          tenant_id={assignLLModal.tenant_id}
          openModal={assignLLModal.openModal}
          handleCloseModal={handleCloseModal}
        />
      )}
      <Modal
        show={effortRateModal}
        onHide={() => setEffortRateModal(false)}
        centered
        className="newmodalui asguarantor"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("effortRate")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="effortpopup-style">
              <p className="percentage_salary_p search_heading01">
                {_t("percentageOfRentFromSalary")}
              </p>
              <div className="d-flex justify-content-between rangemr-set mr-2">
                <div className="col-sm-12">
                  <RentSlider
                    className="rent-slider"
                    defaultValue={effortRatePecentage}
                    aria-label="Default"
                    onChangeCommitted={changeEffortRatePercentage}
                    valueLabelDisplay="on"
                    valueLabelFormat={(value) => `${value}%`}
                    marks={marks}
                    min={1}
                    max={100}
                  />
                </div>
              </div>
            </div>
            <button
              onClick={handleEffortRateSubmit}
              className="btn btnorange w-100"
              type="button"
            >
              {_t("submit")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProfileRequest;
